"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tags = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var ResultsContainer_1 = require("../Search/ResultsContainer");
var SearchBoxWithFilter_1 = require("../Search/SearchBoxWithFilter");
var Select_1 = require("../Select/Select");
var SelectSharedComponents_1 = require("../Select/SelectSharedComponents");
var SelectUtil_1 = require("../Select/SelectUtil");
var TagOption_1 = require("./TagOption");
var TagsContainer = styled_components_1.default.div.attrs({ className: 'tws-tags-container' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-bottom: 6px;\n\t& > div {\n\t\tdisplay: block;\n\t}\n"], ["\n\tdisplay: block;\n\tmargin-bottom: 6px;\n\t& > div {\n\t\tdisplay: block;\n\t}\n"])));
TagsContainer.displayName = 'TagsContainer';
var ResultsContainer = (0, styled_components_1.default)(ResultsContainer_1.ResultsContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tright: 0;\n"], ["\n\tright: 0;\n"])));
ResultsContainer.displayName = 'ResultsContainer';
var OptionsHeadline = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: ", ";\n\tpadding: ", " ", ";\n"], ["\n\tcolor: ", ";\n\tpadding: ", " ", ";\n"])), globalVars_module_scss_1.default.mainGray, globalVars_module_scss_1.default.spacing10, globalVars_module_scss_1.default.spacing15);
OptionsHeadline.displayName = 'OptionsHeadline';
var NoResultsContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tcolor: ", ";\n\tpadding: ", " ", " ", " ", ";\n\tfont-style: italic;\n"], ["\n\tcolor: ", ";\n\tpadding: ", " ", " ", " ", ";\n\tfont-style: italic;\n"])), globalVars_module_scss_1.default.secondaryGray1, globalVars_module_scss_1.default.spacing10, globalVars_module_scss_1.default.spacing15, globalVars_module_scss_1.default.spacing30, globalVars_module_scss_1.default.spacing15);
NoResultsContainer.displayName = 'NoResultsContainer';
var SearchInnerContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: relative;\n"], ["\n\tposition: relative;\n"])));
SearchInnerContainer.displayName = 'SearchInnerContainer';
var Tags = /** @class */ (function (_super) {
    __extends(Tags, _super);
    function Tags(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = false;
        _this.updateSearch = function (searchText) {
            var originalItems = _this.state.originalItems;
            var filteredItems;
            var lowerCaseSearchText = searchText.toLowerCase();
            if (searchText === '') {
                filteredItems = __spreadArray([], originalItems, true);
            }
            else {
                filteredItems = lodash_1.default.filter(__assign({}, originalItems), function (option) {
                    return option.displayText.toLowerCase().includes(lowerCaseSearchText);
                });
            }
            // refresh the dropdown list
            _this.setState({ items: filteredItems, searchText: searchText });
        };
        _this.clearSearch = function () {
            _this.updateSearch('');
            _this.maybeFocus(true, true);
        };
        // function should only be called by the click event on the Add as new button
        _this.onAddNew = function () {
            var onAddNew = _this.props.onAddNew;
            var searchText = _this.state.searchText;
            if (onAddNew) {
                onAddNew({ name: searchText, displayText: searchText });
            }
        };
        _this.state = {
            items: _this.props.items ? __spreadArray([], _this.props.items, true) : [],
            open: false,
            searchText: '',
            selectedValues: _this.props.selectedValues || [],
            originalSelectedValues: lodash_1.default.cloneDeep(_this.props.selectedValues) || [],
            originalItems: lodash_1.default.cloneDeep(_this.props.items) || [],
        };
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.handleOnFocus = _this.handleOnFocus.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.toggleDropdown = _this.toggleDropdown.bind(_this);
        _this.onApply = _this.onApply.bind(_this);
        _this.selectionRef = React.createRef();
        return _this;
    }
    Tags.getDerivedStateFromProps = function (props, state) {
        var isSelectedValuesChanged = !lodash_1.default.isEqual(props.selectedValues, state.originalSelectedValues);
        var isItemsChanged = !lodash_1.default.isEqual(props.items, state.originalItems);
        var newState = __assign({}, state);
        if (isSelectedValuesChanged && props.selectedValues) {
            newState = __assign(__assign({}, newState), { selectedValues: props.selectedValues || [], originalSelectedValues: lodash_1.default.cloneDeep(props.selectedValues || []) });
        }
        if (isItemsChanged) {
            newState = __assign(__assign({}, newState), { searchText: '', items: props.items, originalItems: lodash_1.default.cloneDeep(props.items || []) });
        }
        return newState;
    };
    Tags.prototype.componentWillUnmount = function () {
        this.clearFocusTime();
        this.clearBlurTime();
    };
    Tags.prototype.render = function () {
        var selectedValues = this.props.selectedValues;
        return (React.createElement(TagsContainer, { className: this.props.className },
            React.createElement(SelectSharedComponents_1.Container, { tabIndex: 1, ref: this.selectionRef, selectWidth: SelectUtil_1.SelectUtil.getSelectWidth(this.props.selectWidth, this.props.selectSize), onBlur: this.handleOnBlur, onFocus: this.handleOnFocus },
                React.createElement(SelectSharedComponents_1.SelectContainer, { onClick: this.toggleDropdown, selectWidth: this.props.selectWidth, size: this.props.size, selectSize: this.props.selectSize, disabled: this.props.disabled, focus: this.focus, error: this.props.error },
                    React.createElement(SelectSharedComponents_1.DisplayText, null, this.props.displayText),
                    this.props.showCount && React.createElement(Select_1.SelectedCount, { size: this.props.size },
                        "(",
                        selectedValues && selectedValues.length,
                        ")"),
                    React.createElement(SelectSharedComponents_1.SelectToggle, { disabled: this.props.disabled, focus: this.focus, size: this.props.size },
                        React.createElement(Common_1.Icon, { name: 'caret-down' }))),
                this.generateDropdown()),
            this.props.message && this.getExtraMessage()));
    };
    Tags.prototype.isSelected = function (name) {
        return this.state.selectedValues.indexOf(name) > -1;
    };
    Tags.prototype.getExtraMessage = function () {
        var message = this.props.message;
        var messages = typeof message === 'string' ? [this.props.message] : message;
        var extraMessages = messages.map(function (m, index) {
            return React.createElement("li", { key: 'input-message-' + index }, m);
        });
        if (this.props.error) {
            return React.createElement(SelectSharedComponents_1.ErrorMessage, null, extraMessages);
        }
        else if (this.props.success) {
            return React.createElement(SelectSharedComponents_1.SuccessMessage, null, extraMessages);
        }
        return null;
    };
    Tags.prototype.generateDropdown = function () {
        var _this = this;
        var _a = this.props, addAsNewText = _a.addAsNewText, applyText = _a.applyText, isAddingTag = _a.isAddingTag, optionsHeadline = _a.optionsHeadline, searchResultsHeadline = _a.searchResultsHeadline, searchNoResultsText = _a.searchNoResultsText;
        var _b = this.state, items = _b.items, searchText = _b.searchText, selectedValues = _b.selectedValues;
        if (!this.state.open) {
            return React.createElement("span", null);
        }
        var applyButton = this.props.multiple || this.props.showApplyButton;
        return (React.createElement(SelectSharedComponents_1.DropdownContainer, { optionsContainerWidth: this.props.optionsContainerWidth, selectWidth: SelectUtil_1.SelectUtil.getSelectWidth(this.props.selectWidth, this.props.selectSize), dropdownSize: this.props.dropdownSize },
            this.props.showSearch && (React.createElement(SelectSharedComponents_1.SearchBoxContainer, null,
                React.createElement(SearchInnerContainer, null,
                    React.createElement(Common_1.Input, { type: 'text', placeholder: this.props.initialSearchText, maxLength: 100, value: this.state.searchText, onChange: function (event) { return _this.updateSearch(event.target.value); } }),
                    React.createElement(ResultsContainer, { show: this.state.searchText.length > 0 && items !== undefined && items.length > 0, onClear: function () { return _this.clearSearch(); }, resultsCount: items ? items.length : 0 }),
                    React.createElement(SearchBoxWithFilter_1.SearchInfoWrapper, null, !this.state.searchText && React.createElement(Common_1.Icon, { className: 'tws-search-icon', name: 'search' }))))),
            items && items.length > 0 && !isAddingTag && (React.createElement(React.Fragment, null,
                React.createElement(OptionsHeadline, null, searchText && searchText.length > 0 ? searchResultsHeadline : optionsHeadline),
                React.createElement(SelectSharedComponents_1.OptionsContainer, { applyButton: applyButton, showSearch: this.props.showSearch }, this.generateOptions()),
                applyButton && (React.createElement(SelectSharedComponents_1.ApplyButtonContainer, null,
                    React.createElement(SelectSharedComponents_1.ApplyButton, { disabled: selectedValues === undefined || (selectedValues && selectedValues.length === 0), size: 'sm', color: 'primary', block: true, onClick: this.onApply }, applyText))))),
            ((searchText && searchText.length > 0 && items.length === 0) || isAddingTag) && (React.createElement(React.Fragment, null,
                React.createElement(OptionsHeadline, null, searchResultsHeadline),
                React.createElement(NoResultsContainer, null, searchNoResultsText),
                React.createElement(SelectSharedComponents_1.ApplyButtonContainer, null,
                    React.createElement(SelectSharedComponents_1.ApplyButton, { disabled: this.props.isAddingTag, size: 'sm', color: 'primary', block: true, onClick: this.onAddNew }, addAsNewText))))));
    };
    // Generate option items
    Tags.prototype.generateOptions = function () {
        var _this = this;
        var options = lodash_1.default.orderBy(this.state.items, ['displayText'], ['asc']);
        return options.map(function (item) { return (React.createElement(TagOption_1.TagOption, { item: item, selected: _this.isSelected(item.name), onChange: _this.handleOnChange, key: item.name }, _this.generateOptionItem(item))); });
    };
    // Generate single option item(Checkbox/Text)
    Tags.prototype.generateOptionItem = function (item) {
        var _this = this;
        var getSelectContent = function () {
            if (_this.props.multiple) {
                return React.createElement(Common_1.Checkbox, { size: 'sm', label: item.displayText, checked: _this.isSelected(item.name) });
            }
            return item.displayText;
        };
        return React.createElement("div", null, getSelectContent());
    };
    Tags.prototype.handleOnChange = function (item, selected) {
        var onChange = this.props.onChange;
        var values = [];
        if (selected) {
            values = __spreadArray(__spreadArray([], this.state.selectedValues, true), [item.name], false);
        }
        else {
            var index = lodash_1.default.indexOf(this.state.selectedValues, item.name);
            if (index > -1) {
                values = __spreadArray(__spreadArray([], this.state.selectedValues.slice(0, index), true), this.state.selectedValues.slice(index + 1, this.state.items.length), true);
            }
        }
        this.setState({ selectedValues: values }, function () {
            if (onChange) {
                onChange(values);
            }
        });
    };
    // function should only be called by the click event on the Apply button
    Tags.prototype.onApply = function () {
        var _this = this;
        var onApply = this.props.onApply;
        var items = this.state.items;
        if (onApply) {
            this.setState({ originalItems: __spreadArray([], items, true) }, function () {
                onApply(_this.state.selectedValues, items);
            });
            this.setOpenState(false, false);
        }
    };
    // function should only be called by the click event on the select container
    Tags.prototype.toggleDropdown = function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.props.disabled) {
            return;
        }
        this.setOpenState(!this.state.open, !this.state.open);
    };
    Tags.prototype.setOpenState = function (open, needFocus) {
        var _this = this;
        if (this.state.open === open) {
            this.maybeFocus(open, needFocus);
            return;
        }
        if (this.props.onDropdownVisibleChange) {
            this.props.onDropdownVisibleChange(open);
        }
        if (!open) {
            this.maybeFocus(open, needFocus);
        }
        this.focus = open;
        var nextState = {
            open: open,
            searchText: '',
        };
        this.setState(nextState, function () {
            if (open) {
                _this.maybeFocus(open, needFocus);
            }
        });
    };
    Tags.prototype.maybeFocus = function (open, needFocus) {
        var _this = this;
        if (needFocus || open) {
            var activeElement = document.activeElement;
            if (this.selectionRef && activeElement !== this.selectionRef) {
                this.focusTimer = setTimeout(function () {
                    _this.selectionRef.current.focus();
                    _this.focus = true;
                }, 10);
            }
        }
    };
    Tags.prototype.timeoutFocus = function () {
        var _this = this;
        if (this.focusTimer) {
            this.clearFocusTime();
        }
        if (this.props.onFocus) {
            this.focusTimer = setTimeout(function () {
                _this.props.onFocus();
            }, 10);
        }
    };
    Tags.prototype.clearFocusTime = function () {
        if (this.focusTimer) {
            clearTimeout(this.focusTimer);
            this.focusTimer = null;
        }
    };
    Tags.prototype.clearBlurTime = function () {
        if (this.blurTimer) {
            clearTimeout(this.blurTimer);
            this.blurTimer = null;
        }
    };
    Tags.prototype.handleOnBlur = function () {
        var _this = this;
        this.blurTimer = setTimeout(function () {
            _this.setState({
                selectedValues: _this.state.originalSelectedValues,
                items: __spreadArray([], _this.state.originalItems, true),
            });
            _this.setOpenState(false, false);
        }, 10);
    };
    Tags.prototype.handleOnFocus = function (e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        this.clearBlurTime();
        this.timeoutFocus();
    };
    // Default props
    Tags.defaultProps = {
        multiple: true,
        selectWidth: 'auto',
        optionsContainerWidth: '100%',
        addAsNewText: 'Add as new tag',
        applyText: 'Apply',
        isAddingTag: false,
        optionsHeadline: 'All tags:',
        searchResultsHeadline: 'Search Results:',
        searchNoResultsText: 'No results to show',
    };
    return Tags;
}(React.Component));
exports.Tags = Tags;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
